import {
  GridActionsCellItem,
  GridActionsCellItemProps,
  GridColDef,
} from "@mui/x-data-grid";

import { ReactElement } from "react";
import DeleteTemplateContainer from "../../../../devices/components/DeleteTemplateContainer";

export const useDeviceTemplatesTableColumns = (): {
  columns: GridColDef[];
} => {
  const columns: GridColDef[] = [
    {
      field: "name",
      headerName: "Name",
      minWidth: 400,
      hideable: false,
      disableColumnMenu: true,
      editable: true,
    },
    {
      field: "numberOfNodes",
      headerName: "Nodes",
      minWidth: 180,
      hideable: false,
      disableColumnMenu: true,
      editable: false,
    },
    {
      field: "templateData",
      headerName: "Template Data",
      minWidth: 350,
      hideable: false,
      disableColumnMenu: true,
      editable: true,
      renderCell: params => {
        const value = params.value;
        try {
          const data = typeof value === "string" ? JSON.parse(value) : value;

          if (!Array.isArray(data)) return "Invalid Data";

          const countForEachDevice: Record<string, number> = {};

          data.forEach((item: any) => {
            if (item?.deviceType) {
              countForEachDevice[item.deviceType] =
                (countForEachDevice[item.deviceType] || 0) + 1;
            }
          });

          const listOfDevices = Object.entries(countForEachDevice)
            .map(([deviceType, count]) => `${deviceType} (${count})`)
            .join(", ");

          return listOfDevices;
        } catch (e) {
          return "Invalid Data";
        }
      },
    },
    {
      field: "action",
      headerName: "Actions",
      minWidth: 240,
      disableColumnMenu: true,
      hideable: false,
      sortable: false,
      type: "actions",
      width: 100,
      getActions: (params): ReactElement<GridActionsCellItemProps>[] => [
        <GridActionsCellItem
          key={`delete-${params.row?.rowId}`}
          icon={<DeleteTemplateContainer row={params.row} />}
          label="Delete"
          className="actionButton"
          disableRipple
        />,
      ],
    },
  ];

  return { columns };
};
